import { ChevronLeft } from 'assets/icons';
import Button from 'components/button';

/**
 * The first card of a record: the way back (`back`: { label, onClick }), what
 * sits on its right (`menu`: the « Actions » of a company), the record's
 * picture (`picture`: its square icon or an avatar), its name, its badge,
 * what it is (`subtitle`), and its actions under it (`children`).
 */
const RecordIdentity = ({ back, menu, picture, title, badge, subtitle, children }) => (
  <section className="rounded-xl border border-gray-100 p-4">
    <div className="mb-4 flex items-center justify-between gap-3">
      <Button color="SECONDARY" size="SM" className="min-w-0 max-w-full" onClick={back.onClick}>
        <span className="flex shrink-0">
          <ChevronLeft wh={18} color="currentColor" />
        </span>
        <span className="truncate">{back.label}</span>
      </Button>
      {menu}
    </div>
    <div className="flex items-start gap-3">
      {picture}
      <div className="min-w-0 flex-1">
        <div className="flex items-start justify-between gap-2">
          <p className="ft-lg font-semibold leading-6 text-gray-900">{title}</p>
          {badge && <span className="shrink-0">{badge}</span>}
        </div>
        {subtitle && <p className="text-xs text-gray-600">{subtitle}</p>}
      </div>
    </div>
    {children}
  </section>
);

// The square picture of a company or a group.
export const RecordIcon = ({ icon: Icon }) => (
  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-gray-100 text-gray-900">
    <Icon wh={24} color="currentColor" />
  </span>
);

export default RecordIdentity;
